import type { HouseholdInsightsApiResponse } from '../apiTypes';
import type { DistributionItem } from '../chartTypes';
import { HOUSEHOLD_SIZE_BUCKETS } from '../constants';
import { parseDistribution } from './utils';

export const parseHouseholdSize = (response: HouseholdInsightsApiResponse | undefined): DistributionItem[] =>
  parseDistribution(response?.household_size, HOUSEHOLD_SIZE_BUCKETS);
